import { getCurrentLanguage } from "../../../../i18n/config";
import { LoginInterface } from "../../domain/interface/login_interface";
import { RegisterInterface } from "../../domain/interface/register_interface";
import { ResetPasswordInterface } from "../../domain/interface/reset_password_interface";
import { AuthRepository } from "../../domain/repository/auth_repository";
import { AuthenticationLocalService } from "../data_source/local/authentication_local_service";
import { AuthenticationApiService } from "../data_source/remote/authentication_api_service";

export class AuthRepositoryImpl implements AuthRepository {
    private authApiService: AuthenticationApiService;
    private authLocalService: AuthenticationLocalService;

    constructor() {
        this.authApiService = new AuthenticationApiService();
        this.authLocalService = new AuthenticationLocalService();
    }

    async login(loginForm: LoginInterface): Promise<boolean> {
        const response = await this.authApiService.login(JSON.stringify({
            'email': loginForm.email,
            'password': loginForm.password
        }));
        if (response.status == 201) {
            this.authLocalService.setAccessToken(response.data.accessToken);
            this.authLocalService.setRefreshToken(response.data.refreshToken);
            return true;
        }
        return false;
    }

    async register(registerForm: RegisterInterface): Promise<boolean> {
        const response = await this.authApiService.register(JSON.stringify({
            'email': registerForm.email,
            'password': registerForm.password,
            'firstname': registerForm.firstname,
            'lastname': registerForm.lastname,
            'birthdate': registerForm.birthdate,
            'companyCode': registerForm.companyPin,
            'gender': registerForm.gender,
            'communication': registerForm.preferences,
            'language': getCurrentLanguage(),
        }));
        if (response.status == 201) {
            this.authLocalService.setAccessToken(response.data.accessToken);
            this.authLocalService.setRefreshToken(response.data.refreshToken);
            return true;
        }
        return false;
    }

    async registerInvitee(registerForm: RegisterInterface): Promise<boolean> {
        const response = await this.authApiService.registerInvitee(JSON.stringify({
            'password': registerForm.password,
            'firstname': registerForm.firstname,
            'lastname': registerForm.lastname,
            'birthdate': registerForm.birthdate,
            'gender': registerForm.gender,
            'token': registerForm.token,
            'language': getCurrentLanguage(),
        }));
        if (response.status == 201) {
            this.authLocalService.setAccessToken(response.data.accessToken);
            this.authLocalService.setRefreshToken(response.data.refreshToken);
            return true;
        }
        return false;
    }

    async checkEmailAvailable(email: string, code: string): Promise<'available' | 'taken' | 'wrongEmailDomain' | 'other'> {
        const response = await this.authApiService.checkEmailAvailable(email, code);
        if (response.status === 200) {
            if (response.data['message'] === 'Email domain is not allowed') {
                return 'wrongEmailDomain';
            }
            return response.data["accountExist"] ? 'taken' : 'available';
        }
        return 'other';
    }

    async sendResetPasswordEmail(email: string): Promise<boolean> {
        await this.authApiService.sendResetPasswordEmail(JSON.stringify({
            'email': email,
        }));
        return true;
    }
    
    async resetPassword(json: ResetPasswordInterface): Promise<boolean> {
        const response = await this.authApiService.resetPassword(JSON.stringify(json));
        if (response.status === 201) {
            return true;
        }
        return false;
    }
}